import { css } from '@emotion/react';
import Mixin from '../../../util/mixin';

// Text truncate
export class TextTruncate extends Mixin {
  style() {
    return css`
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    `;
  }
}
